/*
  Art of Steam Co. — shared sizing engine
  One set of sizing rules used by the sauna heater calculator, the steam generator calculator,
  the "Will it fit?" check on product pages and the comparison page.
  Change a rule here and every tool follows.
*/
(function () {
  if (window.AOS && window.AOS.sizing) return;
  var AOS = (window.AOS = window.AOS || {});

  var RULES = {
    heater: {
      insulation: { good: 1.0, fair: 1.1, poor: 1.2 },
      ceiling: { flat: 1.0, vaulted: 1.1 },
      glassCuFtPerSqFt: 2
    },
    steam: {
      thermasol: {
        label: 'Thermasol', maxHeightFt: 10, maxAdjusted: 1200, baseHeightFt: 8, stepUp: true,
        ladder: [84, 140, 240, 395, 575, 750, 1200],
        consult: 'Ceilings over 10 ft need a custom Thermasol recommendation.'
      },
      kohler: {
        label: 'Kohler', maxHeightFt: 10, maxAdjusted: 1000, baseHeightFt: 8, stepUp: true,
        ladder: [84, 112, 240, 317, 447, 500, 550, 634, 894, 1000],
        consult: 'Ceilings over 10 ft need a custom Kohler recommendation.'
      },
      mrsteam: {
        label: 'Mr. Steam', maxHeightFt: 10, maxAdjusted: 1000,
        wall: { tile: 1.0, stone: 1.5 },
        height: [{ over: 9, mult: 1.3 }, { over: 8, mult: 1.2 }],
        consult: 'Ceilings over 10 ft need a custom Mr. Steam recommendation.'
      },
      amerec: {
        label: 'Amerec', maxAdjusted: 550,
        wall: { tile: 1.0, stone: 1.8 },
        warnHeightFt: 8,
        warn: 'Ceilings over 8 ft can cause uneven temperatures with Amerec generators. Email us and we’ll confirm the size.',
        consult: 'Rooms over 550 adjusted cu. ft. may need more than one Amerec generator.'
      }
    }
  };

  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(/,/g, '')); return isFinite(n) ? n : 0; }
  function ftin(ft, inch) { return num(ft) + num(inch) / 12; }

  function brandKey(vendor) {
    var v = String(vendor || '').toLowerCase();
    if (v.indexOf('thermasol') > -1) return 'thermasol';
    if (v.indexOf('mr') > -1 && v.indexOf('steam') > -1) return 'mrsteam';
    if (v.indexOf('amerec') > -1) return 'amerec';
    if (v.indexOf('kohler') > -1) return 'kohler';
    return null;
  }

  // Sauna heaters: L x W x H x insulation x ceiling, plus 2 cu ft per sq ft of glass. No outdoor multiplier.
  function heater(room) {
    var base = Math.max(0, num(room.L) * num(room.W) * num(room.H));
    var ins = RULES.heater.insulation[room.insulation] || 1;
    var ceil = RULES.heater.ceiling[room.ceiling] || 1;
    var adjusted = base * ins * ceil + num(room.glass) * RULES.heater.glassCuFtPerSqFt;
    return { base: base, adjusted: adjusted };
  }

  function heaterFit(adjusted, min, max) {
    min = num(min); max = num(max);
    if (!(adjusted > 0) || !(max > 0)) return { status: 'unknown' };
    if (adjusted > max) return { status: 'small', label: 'Too small for this room' };
    if (min > 0 && adjusted < min) return { status: 'big', label: 'More power than this room needs' };
    return { status: 'fits', label: 'Fits your room' };
  }

  // Steam: per-brand rules. Returns the size the room needs for that brand.
  function steam(key, room, ladderOverride) {
    var b = RULES.steam[key];
    var L = num(room.L), W = num(room.W), H = num(room.H);
    var base = Math.max(0, L * W * H);
    if (!b) return { status: 'unknown', base: base, adjusted: base };
    var adjusted = base;
    if (b.wall) adjusted *= (b.wall[room.wall] || 1);
    if (b.maxHeightFt && H > b.maxHeightFt) return { status: 'consult', base: base, adjusted: adjusted, message: b.consult };
    if (b.height) {
      for (var i = 0; i < b.height.length; i++) { if (H > b.height[i].over) { adjusted *= b.height[i].mult; break; } }
    }
    if (b.stepUp) {
      var ladder = (ladderOverride && ladderOverride.length ? ladderOverride : b.ladder).slice().sort(function (a, c) { return a - c; });
      var size = null;
      for (var j = 0; j < ladder.length; j++) { if (adjusted <= ladder[j]) { size = j; break; } }
      if (size === null) return { status: 'consult', base: base, adjusted: adjusted, message: b.consult };
      var extra = Math.ceil(Math.max(0, H - b.baseHeightFt));
      size = Math.min(ladder.length - 1, size + extra);
      if (extra && size === ladder.length - 1 && adjusted > ladder[ladder.length - 1]) {
        return { status: 'consult', base: base, adjusted: adjusted, message: b.consult };
      }
      if (extra) adjusted = Math.max(adjusted, ladder[size]);
    }
    if (b.maxAdjusted && adjusted > b.maxAdjusted) return { status: 'consult', base: base, adjusted: adjusted, message: b.consult };
    if (b.warnHeightFt && H > b.warnHeightFt) return { status: 'warning', base: base, adjusted: adjusted, message: b.warn };
    return { status: 'ok', base: base, adjusted: adjusted };
  }

  function steamFit(result, max) {
    max = num(max);
    if (!result || !(result.base > 0) || !(max > 0)) return { status: 'unknown' };
    if (result.status === 'consult') return { status: 'consult', label: 'Contact us to size this room', message: result.message };
    if (result.adjusted > max) return { status: 'small', label: 'Too small for this room' };
    return { status: result.status === 'warning' ? 'warning' : 'fits', label: 'Fits your room', message: result.message };
  }

  // Room details are remembered in this browser so the calculator, product pages and compare page agree.
  var KEY = 'aos_room';
  function loadRoom() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function saveRoom(r) { try { localStorage.setItem(KEY, JSON.stringify(r)); } catch (e) {} }

  AOS.sizing = {
    rules: RULES, num: num, ftin: ftin, brandKey: brandKey,
    heater: heater, heaterFit: heaterFit, steam: steam, steamFit: steamFit,
    loadRoom: loadRoom, saveRoom: saveRoom
  };

  // Compare list (per browser): { steam: [handles], electric: [...], wood: [...] }
  var CKEY = 'aos_compare';
  function loadCompare() { try { return JSON.parse(localStorage.getItem(CKEY)) || {}; } catch (e) { return {}; } }
  function saveCompare(c) { try { localStorage.setItem(CKEY, JSON.stringify(c)); } catch (e) {} document.dispatchEvent(new CustomEvent('aos:compare-changed')); }
  AOS.compare = {
    max: 4,
    list: function (cat) { return (loadCompare()[cat] || []).slice(); },
    all: loadCompare,
    has: function (cat, h) { return (loadCompare()[cat] || []).indexOf(h) > -1; },
    toggle: function (cat, h) {
      var c = loadCompare(); var l = c[cat] || [];
      var i = l.indexOf(h);
      if (i > -1) l.splice(i, 1); else { if (l.length >= this.max) return false; l.push(h); }
      c[cat] = l; saveCompare(c); return true;
    },
    remove: function (cat, h) { var c = loadCompare(); c[cat] = (c[cat] || []).filter(function (x) { return x !== h; }); saveCompare(c); },
    count: function () { var c = loadCompare(); return Object.keys(c).reduce(function (n, k) { return n + (c[k] || []).length; }, 0); }
  };
})();
